import { render, staticRenderFns } from "./ArgInputProductSku.vue?vue&type=template&id=1feca564"
import script from "./ArgInputProductSku.vue?vue&type=script&lang=ts"
export * from "./ArgInputProductSku.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports